import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({

  pendingWrapper: {
    marginTop: "60px"
  },
  pendingTitle: {
    color: theme.palette.grey.grey400,
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "center",
    marginTop: "20px"
  },
  pendingSubTitle: {
    whiteSpace: "pre-line",
    color: theme.palette.grey.grey400,
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "center"
  },
  pendingLoadingBar: {
    height: 10,
    width: "800px",
    margin: "auto",
    borderRadius: 5,
    "& .MuiLinearProgress-bar": {
      // apply a new animation-duration to the `.bar` class
      animationDuration: "6s",
      borderRadius: 5,
      backgroundColor: theme.palette.primary.primary600,
    },
    "& .MuiLinearProgress-bar2Indeterminate": {
      display: "none"
    },
    "&.MuiLinearProgress-colorPrimary": {
      backgroundColor: theme.palette.grey.grey200,

    }
  },
}));

export default useStyles;
